var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.splitText),function(c,i){return _c('span',{key:c + i,class:c == ' ' ? 'space' : '',style:(("transform: translateY(" + (_vm.peak * Math.sin((i + _vm.shift) / _vm.period)) + "px)"))},[_vm._v(_vm._s(c))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }